'use strict';

var AppDispatcher = require('../AppDispatcher'),
    ActionTypes = require('../constants/ActionTypes'),
    PaginatedStoreUtils = require('../utils/PaginatedStoreUtils'),
    ActivityStore = require('./ActivityStore'),
    UserStore = require('./UserStore'),
    { createListStore, createListActionHandler } = PaginatedStoreUtils;

var _unseenCount = 0,
    _expanded = {};

function expandActivities(activity) {
  if (_expanded[activity.id]) {
    return activity.aggregated.map(ActivityStore.get);
  }
  return activity;
}

var ActivityListStore = createListStore({
  getActivities() {
    return this.getIds(UserStore.getMe().id).map(ActivityStore.get).map(expandActivities);
  },

  getUnseenCount() {
    return _unseenCount;
  }
});

function getList() {
  return ActivityListStore.getList(UserStore.getMe().id);
}

var handleListAction = createListActionHandler({
  request: ActionTypes.REQUEST_ACTIVITIES,
  error: ActionTypes.REQUEST_ACTIVITIES_ERROR,
  success: ActionTypes.REQUEST_ACTIVITIES_SUCCESS
});

AppDispatcher.register(function (payload) {
  AppDispatcher.waitFor([ActivityStore.dispatchToken]);

  var action = payload.action,
      list;

  if (!UserStore.getMe()) {
    return;
  }

  list = getList();

  handleListAction(action, list, ActivityListStore.emitChange);

  switch (action.type) {
    case ActionTypes.INVALIDATE_ACTIVITIES:
      ActivityListStore.invalidate();
      break;

    case ActionTypes.ACTIVITY_MARK_ALL_SUCCESS:
      _unseenCount = 0;
      ActivityListStore.emitChange();
      break;

    case ActionTypes.REQUEST_UNSEEN_ACTIVITY_COUNT_SUCCESS:
      _unseenCount = action.count;
      ActivityListStore.emitChange();
      break;

    case ActionTypes.ACTIVITY_EXPAND:
      _expanded[action.activityId] = true;
      ActivityListStore.emitChange();
      break;
  }
});

module.exports = ActivityListStore;


/** WEBPACK FOOTER **
 ** ./stores/ActivityListStore.js
 **/